module.exports = {
      id: "edit-usage",
      viewBox: "0 96 960 960",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#edit",
      toString: function () {
        return this.url;
      }
    }